"use client";

import { useTransition } from "react";
import { useRouter } from "next/navigation";

/**
 * „Tour wiederholen" im Benutzermenü. Verhalten unverändert zum Bestand
 * (topbar-right RestartOnboardingButton): Onboarding zurücksetzen, danach
 * nach /dashboard; Fehler werden wie bisher verschluckt.
 */
export function TourWiederholen({
  className,
  tourNeuStarten,
  symbol,
}: {
  className: string;
  tourNeuStarten: () => Promise<void>;
  /** Symbol vor dem Text (Konto-Menü P2); fehlt es, steht nur der Text. */
  symbol?: React.ReactNode;
}) {
  const [isPending, startTransition] = useTransition();
  const router = useRouter();

  function handle() {
    startTransition(async () => {
      try {
        await tourNeuStarten();
        router.push("/dashboard");
      } catch {
        // wie bisher: kein Hinweis
      }
    });
  }

  return (
    <button type="button" onClick={handle} disabled={isPending} className={className}>
      {symbol}
      Tour wiederholen
    </button>
  );
}
